import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import { isNative } from "@/lib/native";
import DownloadApp from "@/pages/DownloadApp";
import Paywall from "@/pages/Paywall";

// The website is closed: in the browser only admins can use the panel.
export default function WebGate() {
  const { user } = useAuth();
  const { pathname } = useLocation();
  if (isNative()) return user?.has_access ? <Outlet /> : <Paywall />;
  if (user?.role !== "admin") return <DownloadApp />;
  return pathname.startsWith("/admin") ? <Outlet /> : <Navigate to="/admin" replace />;
}
